import './App.css';
import Header from './section/Header';
import Layout from './components/Layout';
import Footer from './section/Footer';

function App() {
  return <>
    <Layout children={
      <div>
        <Header />
        <Footer />
      </div>
    } />
  </>

}

export default App;
